import type { TaxBracket } from '../../types/tax';

export const TAX_BRACKETS_2026_27: TaxBracket[] = [
  {
    min: 1,
    max: 245100,
    rate: 0.18,
    baseAmount: 0
  },
  {
    min: 245101,
    max: 383100,
    rate: 0.26,
    baseAmount: 44118
  },
  {
    min: 383101,
    max: 530200,
    rate: 0.31,
    baseAmount: 79998
  },
  {
    min: 530201,
    max: 695800,
    rate: 0.36,
    baseAmount: 125599
  },
  {
    min: 695801,
    max: 887000,
    rate: 0.39,
    baseAmount: 185215
  },
  {
    min: 887001,
    max: 1878600,
    rate: 0.41,
    baseAmount: 259783
  },
  {
    min: 1878601,
    max: null, // No upper limit
    rate: 0.45,
    baseAmount: 666339
  }
];

export const TAX_YEAR_2026_27 = '2026-27';
export const TAX_YEAR_2026_27_START = new Date('2026-03-01');
export const TAX_YEAR_2026_27_END = new Date('2027-02-28');
